export const createShortcut = (commandKey, defaultKey, args) => ({
    commandKey,
    defaultKey,
    args,
});
//# sourceMappingURL=create-shortcut.js.map